<template>
	<c-modal @close="close" :title="'Tarief bewerken'">

		<div class="text-wrap">
			<p class="margin-t-32">{{ product.name }}</p>

            <c-form ref="form" @valid="submit" class="margin-t-40">

                <c-input
                    :label="'Prijs'"
                    :horizontal="true"
                    :required="false"
                    v-model="price"
                    name="price"/>

                <div class="row collapse align-right">
                    <div class="columns shrink">
                        <c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Opslaan</c-button>
                    </div>
                </div>
                
            </c-form>

		</div>
	</c-modal>
</template>

<script>
import CModal from '@components/Modal';
import Form from '@mixins/Form';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal
	},
    data() {
        return {
            product: {},
            price: '',
        }
    },
	props: {
        product_id: {
            required: false
        }
	},
	methods: {
		close() {
			this.$emit('close');
		},
        load() {
			this.$xhr.get("/api/products/" + this.product_id)
				.then( ({result}) => {
					this.product = result;
                    this.price = result.price ? result.price.price.replace('.', ',') : '';
				})

		},
        submit(){
            this.$xhr.post("/api/products/" + this.product_id + "/prices", {price: this.price})
				.then( ({result}) => {
                    this.close()
                    this.$emit('reload');
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
                });
        }
	},
    mounted(){
        this.load();
    }
}
</script>